import { Hero } from "../components/Hero";
import { ServicesList } from "../components/ServicesList";
import { CaseStudies } from "../components/CaseStudies";
import { Reviews } from "../components/Reviews";
import { Statement } from "../components/Statement";
import { About } from "../components/About";
import { Location } from "../components/Location";
import { BookingCard } from "../components/BookingCard";
import { FAQ } from "../components/FAQ";
import { TrustedBy } from "../components/TrustedBy";

export function HomePage() {
  return (
    <>
      <main id="main">
        <Hero />
        <TrustedBy />
        <ServicesList />
        <CaseStudies />
        <Statement />
        <Reviews />
        <About />
        <Location />
        <FAQ />
        <BookingCard />
      </main>
    </>
  );
}
